import Symbol from "./Symbol";
import { INSPECTOR_FIXED_CAPACITOR_BANK } from "../../../constants/inspectorConstants";

// Bancos de capacitores fijos
class FixedCapacitorBank extends Symbol {
    constructor({ alias, svgSrc, label, rotable, handles, name}) {
        super("FixedCapacitorBank", { alias, svgSrc, label, rotable, handles, name });

        this.attributes = {
            ...this.attributes,
            brand: { isVisible: false, value: null, label: "Marca" },
            model: { isVisible: false, value: null, label: "Modelo" },
            ratedVoltage: { isVisible: false, value: null, label: "Voltaje nominal" },
            ratedCurrent: { isVisible: false, value: null, label: "Corriente Nominal" },
            kVAR: { isVisible: false, value: null, label: "kVAR" },
        };                
    }

    getInspector() {
        return INSPECTOR_FIXED_CAPACITOR_BANK;
    }
}

export default FixedCapacitorBank;
